export default __webpack_public_path__ + "static/img_product_brc@2x-7856800e778b1692c189d1a9a53e1244.png";